import React, { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { initializeGTM, trackPageView } from "../utils/gtm";

const Index = () => {
  const location = useLocation();
  const previousPathRef = useRef("");

  useEffect(() => {
    const currentPath = `${location.pathname}${location.search}${location.hash}`;

    initializeGTM({ forceReload: true });
    trackPageView(currentPath, previousPathRef.current);
    previousPathRef.current = currentPath;
  }, [location.pathname, location.search, location.hash]);

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
